import { useAuthQuery } from "@rentablo/api";
import { loadDividendsPerYerForInvestment } from "@api";

export const useDividendsPerYearForInvestment = (investmentId?: number) => {
  return useAuthQuery(
    ["dividends-per-year", investmentId!],
    ({ token }) => loadDividendsPerYerForInvestment(token, investmentId!),
    {
      enabled: !!investmentId,
    }
  );
};
